// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"212a11bf","250":"cda9631d","261":"f53cbab9","449":"9c71b3e0","552":"11f03f67","604":"b312334c","927":"76d77a9d","981":"b369cd17"}[chunkId] + ".chunk.js";
};